import { makeStyles, styled } from "@mui/styles";
import { Box } from "@mui/system";

export default makeStyles((theme) => ({
  imageLink: {
    display: "flex",
    justifyContent: "center",
    padding: "10% 0",
  },
  image: {
    width: "70%",
  },
  links: {
    color: theme.palette.text.primary,
    textDecoration: "none",
  },
  genreImage: {
    filter: theme.palette.mode === "dark" && "invert(1)",
  },
}));
export const StyledLink = styled(Box)(({ theme }) => ({
  color: theme.palette.text.primary,
  textDecoration: "none",
}));
